import React from 'react';

const LINKEDIN_URL = 'https://www.linkedin.com/in/raghav-sharma-8a126434b/';
const EMAIL = 'raghavsharma.070901@gmail.com';
const GAME_URL = 'https://memory-game.raghavsharma.codes/';

const WORK_PARAGRAPHS = [
  "For now, Imma hard-code \"Loading…\" here while I quietly organise my GitHub.",
  <>Till then you can find me on <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer">LinkedIn</a> and <a href={`mailto:${EMAIL}`}>Email</a> or maybe enjoy a little game <a href={GAME_URL} target="_blank" rel="noopener noreferrer">Here</a>.</>,
];

export default function Work() {
  return (
    <section id="work" className="panel">
      <h3>Work</h3>
      {WORK_PARAGRAPHS.map((paragraph, index) => (
        <p key={index}>{paragraph}</p>
      ))}
    </section>
  );
}

